import React from 'react';
import { useLabels } from 'wsm-common-data';

const ErrorMessage = () => {
	const labels = useLabels();
	return (
		<div className="error-message">
			<h1>{labels.get('WS_STL_ERROR_HEADER')}</h1>
			<p>{labels.get('WS_STL_ERROR_BODY')}</p>
		</div>
	);
};

export default ErrorMessage;
